import { render, staticRenderFns } from "./TipboxPolicies.vue?vue&type=template&id=7953b9cc&scoped=true"
import script from "./TipboxPolicies.vue?vue&type=script&lang=js"
export * from "./TipboxPolicies.vue?vue&type=script&lang=js"
import style0 from "./TipboxPolicies.vue?vue&type=style&index=0&id=7953b9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953b9cc",
  null
  
)

/* custom blocks */
import block0 from "./TipboxPolicies.vue?vue&type=custom&index=0&blockType=i18n&lang=json&locale=pl&scope=local"
if (typeof block0 === 'function') block0(component)
import block1 from "./TipboxPolicies.vue?vue&type=custom&index=1&blockType=i18n&lang=json&locale=en&scope=local"
if (typeof block1 === 'function') block1(component)

export default component.exports